"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("../../layout/Grid/Grid"));
const FNumber_1 = __importDefault(require("../component/FNumber"));
function calcF(index, s) {
    return 15 * index <= s && s < 15 * index + 15 ? s - 15 * index : undefined;
}
function default_1(props) {
    const { clock } = props;
    const { s, m, h } = clock;
    if (typeof h === 'string' || typeof m === 'string' || typeof s === 'string') {
        return null;
    }
    const h1 = Math.floor(h / 10);
    const h2 = h % 10;
    const m1 = Math.floor(m / 10);
    const m2 = m % 10;
    const s1 = calcF(0, s);
    const s2 = calcF(1, s);
    const s3 = calcF(2, s);
    const s4 = calcF(3, s);
    return (react_1.default.createElement(Grid_1.default, { className: "glx-num-clock", flex: true, flexR: true, gap: 8 },
        react_1.default.createElement(FNumber_1.default, { start: 0, num: h1, second: s1 }),
        react_1.default.createElement(FNumber_1.default, { start: 15, num: h2, second: s2 }),
        react_1.default.createElement("div", null),
        react_1.default.createElement(FNumber_1.default, { start: 30, num: m1, second: s3 }),
        react_1.default.createElement(FNumber_1.default, { start: 45, num: m2, second: s4 })));
}
exports.default = default_1;
